var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex w-full items-center gap-4" },
    [
      _c(
        "div",
        [
          _c(
            "jade-dropdown",
            {
              attrs: { allowedPlacements: ["bottom-start"], open: _vm.open },
              on: {
                toggleOpen: function ($event) {
                  _vm.open = !_vm.open
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "trigger",
                  fn: function () {
                    return [
                      _c(
                        "jade-action-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            active: !!_vm.selectedStatus,
                            dropdownIndicator: "",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(_vm.selectedStatus?.label || "status")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            _vm._l(_vm.statusFilterOptions, function (option) {
              return _c("jade-list-item", {
                key: option?.value,
                attrs: {
                  variant:
                    _vm.selectedStatus?.value === option?.value
                      ? "active"
                      : "primary",
                  label: option.label,
                  as: "button",
                },
                on: {
                  onClick: function ($event) {
                    return _vm.applyFilterStatus(option)
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "page-down",
                        undefined,
                        $event.key,
                        undefined
                      )
                    )
                      return null
                    return _vm.applyFilterStatus(option)
                  },
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("JadeInputField", {
        attrs: {
          label: "",
          size: "medium",
          value: _vm.id,
          placeholder: _vm.$t("placeholder"),
          leadingItem: { type: "icon", content: "action-search" },
        },
        on: {
          "update:value": function ($event) {
            _vm.id = $event
          },
        },
      }),
      _c(
        "JadeButton",
        {
          staticClass: "w-28",
          attrs: {
            variant: "primary-solid",
            size: "medium",
            disabled: _vm.loading,
          },
          on: { click: _vm.searchClick },
        },
        [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }